import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ClayGlobe from "../components/ClayGlobe";

const Landing = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "The Monde Mania";
  }, []);

  const enter = () => navigate("/home");

  return (
    <div className="landing">
      <div className="landing-vignette" />
      <div className="landing-stage">
        <div className="globe-frame">
          <ClayGlobe textureUrl="/img/tmm_equirect.webp" heightUrl="/img/tmm_height.webp" />
          <div className="globe-shadow" />
        </div>
        <button
          type="button"
          className="landing-enter"
          onClick={enter}
          onTouchEnd={(e) => {
            // Fire immediately on touchend for iOS Safari;
            // prevent default synthetic click so we don't navigate twice.
            e.preventDefault();
            enter();
          }}
          aria-label="Enter site"
        >
          unbounded
        </button>
      </div>
    </div>
  );
};

export default Landing;
